var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download"},[(_vm.wxshow)?_c('img',{staticClass:"downts",attrs:{"src":require("../../../../assets/images/downts.png"),"alt":""}}):_vm._e(),_c('img',{staticClass:"downTitle",attrs:{"src":require("../../../../assets/images/downTitle.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }